import styled from 'styled-components';

import { IPDPState } from 'store/types/pdpStateTypes';
import { useStoreDispatch, useStoreSelector } from 'store/hooks/storeHooks';
import { setBigBuyBarView } from 'store/slice/pdpStateSlice';

interface IBigBuyBarDesktopTabButton {
  tab: IPDPState['bigBuyBarView'];
  title: string;
  'data-qa'?: string;
  onClick?: () => void;
}

export const BigBuyBarDesktopTabButton = ({
  tab,
  title,
  onClick,
  ...props
}: IBigBuyBarDesktopTabButton) => {
  const { bigBuyBarView } = useStoreSelector((state) => state.pdpState);
  const storeDispatch = useStoreDispatch();
  const isActive = tab === bigBuyBarView;

  const handleTabClicked = (tabValue: IPDPState['bigBuyBarView']) => {
    storeDispatch(setBigBuyBarView(tabValue));
    onClick?.();
  };

  return (
    <BigBuyBarDesktopTabButton.Button
      onClick={() => handleTabClicked(tab)}
      $isActive={isActive}
      data-qa={props['data-qa']}
    >
      {title}
    </BigBuyBarDesktopTabButton.Button>
  );
};

BigBuyBarDesktopTabButton.Button = styled.button<{ $isActive: boolean }>`
  box-sizing: border-box;
  padding: 0;
  margin: 0 24px;
  display: flex;
  white-space: nowrap;
  border-bottom: 1px solid transparent;
  ${({ $isActive }) => $isActive && `border-bottom: 1px solid #000;`}

  &:active, &:hover {
    border-bottom: 1px solid #000;
  }
`;
